module.exports = __webpack_public_path__ + "static/media/f2.45f126c1.png";